/**
 * Shared logging helpers
 * Silences logs during tests (NODE_ENV=test) without affecting production
 */

/**
 * Log debug message (silenced in test mode)
 */
export function logDebug(message: string): void {
  // @ts-ignore - process.env may be injected by bundler
  if (typeof process !== "undefined" && process.env && process.env.NODE_ENV === "test") {
    return; // Silence in test mode
  }
  if (typeof console !== "undefined" && console.log) {
    console.log(message);
  }
}

/**
 * Log error message (silenced in test mode)
 */
export function logError(message: string): void {
  // @ts-ignore - process.env may be injected by bundler
  if (typeof process !== "undefined" && process.env && process.env.NODE_ENV === "test") {
    return; // Silence in test mode
  }
  if (typeof console !== "undefined" && console.error) {
    console.error(message);
  }
}
